import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import styled from "styled-components";

const cookies = new Cookies();

const SuccessPage = () => {
  const [message, setMessage] = useState("Verifying payment...");

  useEffect(() => {
    const verify = async () => {
        const hash = window.location.hash;
        const query = hash.split('?')[1];
        const params = new URLSearchParams(query);
        const session_id = params.get('session_id');
        if (!session_id) return setMessage("No session found.");

        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/users/confirmPayment`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${cookies.get("token")}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ session_id }),
            });
            const data = await res.json();
            if (data.status === "paid") {
                setMessage("Payment confirmed! Redirecting...");
                const returnUrl = data.redirectUrl || "/";
                setTimeout(() => {
                    window.location.href = returnUrl;
                }, 2000);
            } else {
                setMessage("Payment pending or failed.");
            }
        } catch (err) {
            console.error(err);
            setMessage("Error verifying payment.");
        }
    };
    verify();
  }, []);

  return <MessageBox>{message}</MessageBox>;
}

export default SuccessPage;

const MessageBox = styled.h3`
    text-align: center;
    height: 100%;
    margin: 0;
    display: grid;
    place-items: center;
`;